/* 国旗の切り替え（国・地域＝通貨／言語）2026-10-15 神城
   1) ヘッダー（PC・追従・スマホ）へ国旗ボタンを置く。置けない画面は左下に出す
   2) 押すと国・地域と言語の一覧。選んだら Shopify 標準の localization フォームで送る
   3) 海外からの初回だけ、国（Shopify の IP 判定）と言語（ブラウザ）に自動で合わせる
      ・手で選んだ人（ehl_manual）と検索ロボットには何もしない。1回の訪問で試すのは1回だけ（ehl_auto）
      ・試験用：URL に ?ehl_geo=US を付けると、その国から来たことにする */
(function () {
  var root = document.getElementById('EhlPanel');
  var tpl = document.getElementById('ehl-trigger');
  var form = document.getElementById('EhlForm');
  if (!root || !tpl || !form) return;
  var T = window.EHL_TEXT || {};
  var d = root.dataset;

  function store(kind, key, val) {
    try { var s = window[kind]; if (val === undefined) return s.getItem(key); if (val === null) s.removeItem(key); else s.setItem(key, val); } catch (e) { return kind === 'localStorage' && key === 'ehl_manual' ? '1' : null; }
  }

  /* 1) ボタンを置く */
  function mount(sel, mode, beforeSel) {
    var n = 0;
    document.querySelectorAll(sel).forEach(function (box) {
      if (box.querySelector('.ehl-btn')) { n++; return; }
      var b = tpl.content.firstElementChild.cloneNode(true);
      b.classList.add('ehl-btn--' + mode);
      var ref = beforeSel ? box.querySelector(beforeSel) : null;
      if (ref && ref.parentNode === box) box.insertBefore(b, ref); else box.insertBefore(b, box.firstChild);
      n++;
    });
    return n;
  }
  var placed = mount('.header-desktop .header-page-link', 'd', '.search-toggle') +
    mount('.header-sticky .header-page-link', 'd', '.search-toggle') +
    mount('.header-top-mobile .header-right', 'm', null);
  if (!placed) {
    var f = tpl.content.firstElementChild.cloneNode(true);
    f.classList.add('ehl-btn--f');
    document.body.appendChild(f);
  }

  /* 2) 一覧 */
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('ehl-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    var bd = root.querySelector('.ehl__body');
    if (bd) bd.scrollTop = 0;
    setTimeout(function () { var x = root.querySelector('.ehl__x'); if (x) x.focus(); }, 80);
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('ehl-lock');
    setTimeout(function () { root.hidden = true; }, 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function submit(country, lang, manual, label, flag) {
    if (manual) store('localStorage', 'ehl_manual', '1');
    form.querySelector('[name=country_code]').value = country;
    form.querySelector('[name=language_code]').value = lang;
    var rt = form.querySelector('[name=return_to]');  /* 戻り先＝今のページ（店側の保存版に別の人のURLが残らないように・試験用の印は外す） */
    if (rt) rt.value = location.pathname + location.search.replace(/([?&])ehl_geo=[A-Za-z]{2}&?/, '$1').replace(/[?&]$/, '');
    if (label) {
      var bz = root.querySelector('.ehl__busy');
      bz.querySelector('span').textContent = T.switching || '…';
      if (flag) bz.querySelector('img').src = flag; else bz.querySelector('img').remove();
      root.classList.add('is-busy');
    }
    form.submit();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-ehl-open],[data-ehl-close],[data-ehl-country],[data-ehl-lang]') : null;
    if (!t) return;
    if (t.hasAttribute('data-ehl-open')) { e.preventDefault(); open(); return; }
    if (t.hasAttribute('data-ehl-close')) { e.preventDefault(); close(); return; }
    if (!root.contains(t)) return;
    e.preventDefault();
    if (t.hasAttribute('data-ehl-country')) {
      var c = t.getAttribute('data-ehl-country');
      var img = t.querySelector('img');
      if (c === d.country) { store('localStorage', 'ehl_manual', '1'); close(); return; }
      submit(c, d.lang, true, true, img && img.src);
    } else {
      var l = t.getAttribute('data-ehl-lang');
      if (l === d.lang) { store('localStorage', 'ehl_manual', '1'); close(); return; }
      submit(d.country, l, true, true, d.flag);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  var q = root.querySelector('.ehl__q');
  if (q) q.addEventListener('input', function () {
    var v = q.value.trim().toLowerCase(), hit = 0;
    root.querySelectorAll('.ehl__list li').forEach(function (li) {
      var b = li.firstElementChild, ok = !v || (b.getAttribute('data-q') || '').indexOf(v) >= 0;
      li.style.display = ok ? '' : 'none';
      if (ok) hit++;
    });
    var none = root.querySelector('.ehl__none');
    if (none) none.style.display = hit ? 'none' : 'block';
    var pop = root.querySelector('.ehl__pop');
    if (pop) pop.style.display = v ? 'none' : '';
  });

  /* 自動で切り替えた直後のあいさつ */
  if (store('sessionStorage', 'ehl_welcome') === '1') {
    store('sessionStorage', 'ehl_welcome', null);
    var t = document.createElement('div');
    t.className = 'ehl-toast';
    t.setAttribute('role', 'status');
    var msg = (T.welcome || '{name} · {cur}').replace('{name}', d.countryName.replace(/[<>&]/g, '')).replace('{cur}', d.currency);
    t.innerHTML = '<img src="' + d.flag + '" alt="" width="34" height="34"><span>' + msg + '</span><button type="button" data-ehl-open>' + (T.change || 'Change') + '</button>';
    document.body.appendChild(t);
    requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add('is-in'); }); });
    t.addEventListener('click', function (e) { if (e.target.closest('[data-ehl-open]')) t.remove(); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 600); }, 6500);
  }

  /* 3) 海外からの初回だけ自動で合わせる */
  var BOT = /bot|crawl|spider|slurp|lighthouse|headless|google|bing|yandex|baidu|duckduck|facebookexternal|semrush|ahrefs|petal|bytespider|gptbot|claude|perplexity|preview/i;
  if (BOT.test(navigator.userAgent || '')) return;
  if (store('localStorage', 'ehl_manual') === '1' || store('sessionStorage', 'ehl_auto') === '1') return;
  if (/[?&](preview_theme_id|oseid)=/.test(location.search) && !/[?&]ehl_geo=/.test(location.search)) return;
  if (location.pathname.indexOf('/checkouts/') >= 0) return;

  function decide(geo) {
    var langs = (d.langs || '').split(',').filter(Boolean);
    var wantC = null, wantL = null;
    if (geo && geo !== d.country && root.querySelector('.ehl__list [data-ehl-country="' + geo + '"]')) wantC = geo;
    var bl = ((navigator.languages && navigator.languages[0]) || navigator.language || '').toLowerCase().split('-')[0];
    if (d.lang === 'ja' && bl && bl !== 'ja') {
      if (langs.indexOf(bl) >= 0) wantL = bl;
      else if (langs.indexOf('en') >= 0) wantL = 'en';
    }
    store('sessionStorage', 'ehl_auto', '1');
    if (!wantC && !wantL) return;
    if (wantC) store('sessionStorage', 'ehl_welcome', '1');
    submit(wantC || d.country, wantL || d.lang, false, false);
  }
  var test = (location.search.match(/[?&]ehl_geo=([A-Za-z]{2})/) || [])[1];
  if (test) { decide(test.toUpperCase()); return; }
  if (!window.fetch) return;
  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=true', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) { decide(j && j.detected_values && j.detected_values.country && j.detected_values.country.handle); })
    .catch(function () {});
})();
